import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Habibi from './Habibi';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Habibi />
  </React.StrictMode>
);
